module.exports = __webpack_public_path__ + "2fca8f66.svg";